var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconKey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_88",
    "data-name": "Groupe 88",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.16,
    height: 21.089,
    viewBox: "0 0 42.16 21.089",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_170",
    "data-name": "Trac\\xE9 170",
    d: "M0,14.542a10.539,10.539,0,0,1,19.669-5.27H36.888a1.317,1.317,0,0,1,.933.385l3.952,3.952a1.317,1.317,0,0,1,0,1.865L37.82,19.427a1.317,1.317,0,0,1-1.865,0l-1.7-1.7-1.7,1.7a1.317,1.317,0,0,1-1.865,0l-1.7-1.7-1.7,1.7a1.317,1.317,0,0,1-1.865,0l-1.7-1.7-1.7,1.7a1.317,1.317,0,0,1-.933.385h-1.41A10.539,10.539,0,0,1,0,14.542Zm10.539-7.9a7.9,7.9,0,1,0,7.146,11.29,1.317,1.317,0,0,1,1.188-.751h1.66l2.248-2.25a1.317,1.317,0,0,1,1.865,0l1.7,1.7,1.7-1.7a1.317,1.317,0,0,1,1.865,0l1.7,1.7,1.7-1.7a1.317,1.317,0,0,1,1.865,0l1.7,1.7,2.089-2.089-2.635-2.635H18.873a1.317,1.317,0,0,1-1.188-.751,7.9,7.9,0,0,0-7.146-4.519Z",
    transform: "translate(0 -3.998)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_171",
    "data-name": "Trac\\xE9 171",
    d: "M6.229,9.114A2.114,2.114,0,1,1,4.114,7,2.114,2.114,0,0,1,6.229,9.114Z",
    transform: "translate(3 0.958)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKey);
export default __webpack_public_path__ + "static/media/icon-key.646f9959ac2fe22e9a71abe3bc22c791.svg";
export { ForwardRef as ReactComponent };